import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation PositionUpdateMutation (
  $workspace: ID!,
  $id: ID!,
  $name: String,
  $shortName: String,
  $color: String,
  $productionResourceType: ProductionResourceTypeInput
) {
  positionUpdate (
    workspace: $workspace
    id: $id
    data: {
      name: $name
      shortName: $shortName
      color: $color
      productionResourceType: $productionResourceType
    }
  ) {
    id
  }
}`

async function requestPositionUpdate (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('position-update', errors)
  }
  return data.positionUpdate
}

export default requestPositionUpdate
